import { render, staticRenderFns } from "./MailboxInlinePicker.vue?vue&type=template&id=3a95955c"
import script from "./MailboxInlinePicker.vue?vue&type=script&lang=js"
export * from "./MailboxInlinePicker.vue?vue&type=script&lang=js"
import style0 from "./MailboxInlinePicker.vue?vue&type=style&index=0&id=3a95955c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports